function isBlank(value) {
  return value === '' || value == null
}

export function agencyTapEngineAddressIncomplete(user) {
  const address = user?.address
  if (!address) return true
  return (
    isBlank(address.address) ||
    isBlank(address.city) ||
    isBlank(address.state) ||
    isBlank(address.zip) ||
    isBlank(address.country)
  )
}

export function agencyRequiresTapEngineAddress(user) {
  return Boolean(
    user &&
      user.role === 'Agency' &&
      user.has_te &&
      agencyTapEngineAddressIncomplete(user)
  )
}
